import { jsx as _jsx } from "react/jsx-runtime";
import { Backdrop, DrawerWrapper } from './Drawer.style';
import { Content, Footer, Header } from './components';
const Drawer = (props) => {
    const { children, isOpen, onClose, size = 'small' } = props;
    const handleStopPropagation = (event) => {
        event.stopPropagation();
    };
    return (_jsx(Backdrop, { isOpen: isOpen, onClick: onClose, children: _jsx(DrawerWrapper, { onClick: handleStopPropagation, isOpen: isOpen, size: size, role: "dialog", "aria-label": "dialog", children: children }) }));
};
Drawer.Header = Header;
Drawer.Content = Content;
Drawer.Footer = Footer;
export default Drawer;
